<bic-popup (close)="onClose()" [customClass]="'w-[560px]'" [hasBackdrop]="true"
           [title]="isRuleset ? 'myCheck teilen' : 'Prüflauf teilen'">
  <div bicPopupContent class="flex flex-col gap-4">
    @if (isRuleset) {
      <p class="text-sm text-gray-900">
        Wählen Sie die Projekte Ihrer Organisation, in denen „{{ checkName }}" ebenfalls verfügbar sein
        soll. Der myCheck wird dabei nicht kopiert: Änderungen in diesem Projekt gelten sofort überall.
        In den anderen Projekten kann er ausgeführt und in Prüfläufen verwendet, aber nicht bearbeitet
        werden.
      </p>
    } @else {
      <p class="text-sm text-gray-900">
        Wählen Sie die Projekte Ihrer Organisation, in denen „{{ checkName }}" ebenfalls verfügbar sein
        soll. Der Prüflauf wird dabei nicht kopiert: Änderungen in diesem Projekt gelten sofort überall,
        in den anderen Projekten kann er ausgeführt und dupliziert, aber nicht bearbeitet werden.
      </p>
    }

    @if (rulesetStep) {
      <!-- Schritt 2 (nur Prüflauf): enthaltene myChecks mitteilen? -->
      @if (missingRulesets.length > 0) {
        <div class="flex flex-col gap-2">
          <span class="text-sm text-gray-900">
            Der Prüflauf verwendet myChecks, die in den gewählten Projekten noch nicht verfügbar sind.
            Ohne sie erscheint er dort ohne Prüfregeln. Sollen sie mitgeteilt werden?
          </span>
          <div class="flex max-h-[240px] flex-col gap-2 overflow-y-auto">
            @for (entry of missingRulesets; track entry.ruleset.id) {
              <label class="flex cursor-pointer flex-row items-center gap-3 rounded-lg border border-gray-200 bg-white px-3 py-2.5 hover:border-green">
                <input (change)="toggleRuleset(entry.ruleset.id)"
                       [checked]="selectedRulesets.has(entry.ruleset.id)"
                       [disabled]="saving"
                       class="h-4 w-4 shrink-0 rounded border-gray-300 text-green accent-green focus:ring-green"
                       type="checkbox"/>
                <span class="flex min-w-0 flex-1 flex-col">
                  <span class="truncate text-sm font-medium text-gray-900">{{ entry.ruleset.name }}</span>
                  <span class="text-xs text-gray-500">Fehlt in: {{ entry.missingIn }}</span>
                </span>
              </label>
            }
          </div>
        </div>
      }
      @if (foreignRulesets.length > 0) {
        <div class="flex flex-row items-start gap-2 rounded-lg border border-yellow-200 bg-yellow-50 p-3">
          <fa-icon [icon]="faTriangleExclamation" class="mt-0.5 shrink-0 text-sm text-yellow-700"></fa-icon>
          <span class="flex flex-col gap-1 text-xs text-yellow-900">
            <span class="font-medium">Diese myChecks gehören einem anderen Projekt und können hier nicht mitgeteilt werden:</span>
            @for (entry of foreignRulesets; track entry.ruleset.id) {
              <span>„{{ entry.ruleset.name }}" ({{ entry.ruleset.ownerProjectName ?? 'anderes Projekt' }}) – fehlt in: {{ entry.missingIn }}</span>
            }
            <span>Teilen Sie sie bei Bedarf aus ihrem Eigentümerprojekt.</span>
          </span>
        </div>
      }
    } @else if (loading) {
      <div class="flex flex-row items-center gap-2">
        <fa-icon [icon]="faSpinnerThird" class="animate-spin text-sm text-gray-500"></fa-icon>
        <span class="text-xs text-gray-500">Projekte werden geladen...</span>
      </div>
    } @else if (loadFailed) {
      <div class="flex flex-row items-start gap-2 rounded-lg border border-yellow-200 bg-yellow-50 p-3">
        <fa-icon [icon]="faTriangleExclamation" class="mt-0.5 shrink-0 text-sm text-yellow-700"></fa-icon>
        <span class="text-xs font-medium text-yellow-900">
          Die Projekte konnten nicht geladen werden. Bitte versuchen Sie es erneut.
        </span>
      </div>
    } @else if (targets.length === 0) {
      <p class="text-xs text-gray-500">
        Es gibt keine weiteren Projekte in dieser Organisation, in denen Sie Mitglied sind. Geteilt
        werden kann nur zwischen Projekten derselben Organisation.
      </p>
    } @else {
      <div class="flex max-h-[280px] flex-col gap-2 overflow-y-auto">
        @for (target of targets; track target.projectId) {
          <label
            [tooltip]="target.allowed ? noTooltip : noPermissionTooltip"
            tooltipDirection="top"
            class="flex flex-row items-center gap-3 rounded-lg border border-gray-200 bg-white px-3 py-2.5"
            [class.cursor-pointer]="target.allowed"
            [class.hover:border-green]="target.allowed"
            [class.opacity-50]="!target.allowed"
            [class.cursor-not-allowed]="!target.allowed">
            <input (change)="toggle(target)"
                   [checked]="isSelected(target)"
                   [disabled]="saving || !target.allowed"
                   class="h-4 w-4 shrink-0 rounded border-gray-300 text-green accent-green focus:ring-green"
                   type="checkbox"/>
            <span class="flex min-w-0 flex-1 flex-col">
              <span class="truncate text-sm font-medium text-gray-900">{{ target.name }}</span>
              @if (target.linked && !isSelected(target)) {
                <span class="text-xs text-red">
                  Freigabe wird aufgehoben{{ isRuleset ? ' – Prüfläufe dort verlieren diesen myCheck' : '' }}
                </span>
              } @else if (target.linked) {
                <span class="text-xs text-gray-500">Bereits geteilt</span>
              }
              @if (target.missingDocumentClasses?.length) {
                <!-- Die Dokumentenklassen werden im Zielprojekt über Standardklasse bzw. Titel
                     zugeordnet; was dort fehlt, schränkt dort nicht ein. -->
                <span class="text-xs text-yellow-800">
                  Dokumentenklassen fehlen dort: {{ target.missingDocumentClasses.join(', ') }} –
                  die Einschränkung darauf entfällt in diesem Projekt.
                </span>
              }
            </span>
          </label>
        }
      </div>

      @if (!hasAllowedTarget) {
        <p class="text-xs text-gray-500">{{ noPermissionTooltip }}</p>
      }

      <!-- Konsequenz der Live-Verlinkung, dauerhaft sichtbar statt einer zweiten Rückfrage. -->
      <div class="flex flex-row items-start gap-2 rounded-lg border border-gray-200 bg-gray-50 p-3">
        <fa-icon [icon]="faCircleInfo" class="mt-0.5 shrink-0 text-sm text-gray-500"></fa-icon>
        <span class="text-xs text-gray-700">
          @if (isRuleset) {
            Hinterlegte Kontextdateien dieses myChecks werden auch bei Prüfungen in den anderen
            Projekten verwendet.
          } @else {
            Die myChecks des Prüflaufs bleiben in ihrem Projekt. Fehlen sie in einem gewählten Projekt,
            werden Sie gefragt, ob sie mitgeteilt werden sollen. Hinterlegte Kontextdateien werden auch
            bei Prüfungen in den anderen Projekten verwendet.
          }
        </span>
      </div>
    }
  </div>

  <div bicPopupButtonGroup class="flex w-full flex-row items-center justify-end gap-4">
    @if (rulesetStep) {
      <bic-button (onClick)="backToTargets()" [disabled]="saving" buttonType="white">Zurück</bic-button>
      <bic-button (onClick)="onConfirm()" [loading]="saving">{{ rulesetConfirmLabel }}</bic-button>
    } @else {
    <bic-button (onClick)="onClose()" [disabled]="saving" buttonType="white">Abbrechen</bic-button>
    <!-- Gesperrt nur, solange sich nichts geändert hat – der Tooltip sagt, warum. -->
    <span [tooltip]="!hasChanges && !loading ? saveDisabledTooltip : noTooltip" tooltipDirection="top">
      <bic-button (onClick)="onConfirm()" [disabled]="!hasChanges" [loading]="saving || loadingRulesets">Speichern</bic-button>
    </span>
    }
  </div>
</bic-popup>
